import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/barber-site.css'
import { initializeSiteTheme } from './lib/site-theme'

const disposeTheme = initializeSiteTheme();
if (import.meta.hot) import.meta.hot.dispose(disposeTheme);

createRoot(document.getElementById("root")!).render(<App />);
